// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise"
import { OpenAPI } from "./core/OpenAPI"
import { request as __request } from "./core/request"
import type {
	ChatUploadDocumentData,
	ChatUploadDocumentResponse,
	ChatSummarizeDocumentData,
	ChatSummarizeDocumentResponse,
	ChatDeleteDocumentData,
	ChatDeleteDocumentResponse,
	ChatCreateConversationData,
	ChatCreateConversationResponse,
	ChatReadConversationsData,
	ChatReadConversationsResponse,
	ChatSseMessagesData,
	ChatSseMessagesResponse,
	ChatReadMessagesData,
	ChatReadMessagesResponse,
	ChatSendMessageData,
	ChatSendMessageResponse,
	ChatDeleteConversationData,
	ChatDeleteConversationResponse,
	ChatUpdateConversationTitleData,
	ChatUpdateConversationTitleResponse,
	ChatHealthCheckResponse,
	ChatTestWorkflowData,
	ChatTestWorkflowResponse,
	ChatsSseMessagesData,
	ChatsSseMessagesResponse,
	ChatsCreateConversationData,
	ChatsCreateConversationResponse,
	ChatsReadConversationsData,
	ChatsReadConversationsResponse,
	ChatsReadMessagesData,
	ChatsReadMessagesResponse,
	ChatsSendMessageData,
	ChatsSendMessageResponse,
	ChatsDeleteConversationData,
	ChatsDeleteConversationResponse,
	ChatsUpdateConversationTitleData,
	ChatsUpdateConversationTitleResponse,
	ChatsStreamChatWithMaintenanceDataData,
	ChatsStreamChatWithMaintenanceDataResponse,
	ChatsChatWithMaintenanceDataData,
	ChatsChatWithMaintenanceDataResponse,
	ChatsStreamAnalyzeMaintenanceRecordsData,
	ChatsStreamAnalyzeMaintenanceRecordsResponse,
	ChatsStreamCostAnalysisData,
	ChatsStreamCostAnalysisResponse,
	ChatsAnalyzeMaintenanceRecordsData,
	ChatsAnalyzeMaintenanceRecordsResponse,
	ExtractorExtractSchemaData,
	ExtractorExtractSchemaResponse,
	ExtractorProcessDocumentData,
	ExtractorProcessDocumentResponse,
	ExtractorGetExtractorResultData,
	ExtractorGetExtractorResultResponse,
	ExtractorStreamExtractorResultData,
	ExtractorStreamExtractorResultResponse,
	ExtractorExtractionData,
	ExtractorExtractionResponse,
	ExtractorMistralExtractionData,
	ExtractorMistralExtractionResponse,
	GenerationStreamGenerateTextData,
	GenerationStreamGenerateTextResponse,
	LoginLoginAccessTokenData,
	LoginLoginAccessTokenResponse,
	LoginTestTokenData,
	LoginTestTokenResponse,
	LoginRecoverPasswordData,
	LoginRecoverPasswordResponse,
	LoginResetPasswordData,
	LoginResetPasswordResponse,
	LoginRecoverPasswordHtmlContentData,
	LoginRecoverPasswordHtmlContentResponse,
	PrivateCreateUserData,
	PrivateCreateUserResponse,
	ReportsReadFeedMetadataData,
	ReportsReadFeedMetadataResponse,
	ReportsReadFeedsData,
	ReportsReadFeedsResponse,
	ReportsCreateFeedData,
	ReportsCreateFeedResponse,
	ReportsReadFeedData,
	ReportsReadFeedResponse,
	ReportsUpdateFeedData,
	ReportsUpdateFeedResponse,
	ReportsDeleteFeedData,
	ReportsDeleteFeedResponse,
	ReportsCreateFeedsBulkData,
	ReportsCreateFeedsBulkResponse,
	ReportsCreateReportJobData,
	ReportsCreateReportJobResponse,
	ReportsListReportJobsData,
	ReportsListReportJobsResponse,
	ReportsGetReportJobData,
	ReportsGetReportJobResponse,
	ReportsUpdateReportJobData,
	ReportsUpdateReportJobResponse,
	ReportsDeleteReportJobData,
	ReportsDeleteReportJobResponse,
	ReportsListReportsByJobIdData,
	ReportsListReportsByJobIdResponse,
	ReportsUpdateReportData,
	ReportsUpdateReportResponse,
	ReportsGetReportByIdData,
	ReportsGetReportByIdResponse,
	ReportsCreateReportData,
	ReportsCreateReportResponse,
	SchemaCreateSchemaData,
	SchemaCreateSchemaResponse,
	SchemaGetSchemasData,
	SchemaGetSchemasResponse,
	SchemaGetSchemaData,
	SchemaGetSchemaResponse,
	SchemaUpdateSchemaData,
	SchemaUpdateSchemaResponse,
	SchemaDeleteSchemaData,
	SchemaDeleteSchemaResponse,
	StorageGetPresignedUrlData,
	StorageGetPresignedUrlResponse,
	StorageCreateFolderData,
	StorageCreateFolderResponse,
	StorageUpdateFolderData,
	StorageUpdateFolderResponse,
	StorageDeleteFolderData,
	StorageDeleteFolderResponse,
	StorageReadFoldersData,
	StorageReadFoldersResponse,
	StorageListFoldersData,
	StorageListFoldersResponse,
	StorageListFilesData,
	StorageListFilesResponse,
	StorageDeleteFilesData,
	StorageDeleteFilesResponse,
	StorageUploadFilesData,
	StorageUploadFilesResponse,
	StorageGetDocumentStatusData,
	StorageGetDocumentStatusResponse,
	StorageListDocumentsData,
	StorageListDocumentsResponse,
	StorageListFilesWithStatusInFolderData,
	StorageListFilesWithStatusInFolderResponse,
	StorageStreamFolderStatusData,
	StorageStreamFolderStatusResponse,
	TableFieldsReadTableFieldsData,
	TableFieldsReadTableFieldsResponse,
	TableFieldsCreateTableFieldData,
	TableFieldsCreateTableFieldResponse,
	TableFieldsReadTableFieldData,
	TableFieldsReadTableFieldResponse,
	TableFieldsUpdateTableFieldData,
	TableFieldsUpdateTableFieldResponse,
	TableFieldsDeleteTableFieldData,
	TableFieldsDeleteTableFieldResponse,
	TableRowsReadTableRowsData,
	TableRowsReadTableRowsResponse,
	TableRowsCreateTableRowData,
	TableRowsCreateTableRowResponse,
	TableRowsUpdateTableRowData,
	TableRowsUpdateTableRowResponse,
	TableRowsDeleteTableRowData,
	TableRowsDeleteTableRowResponse,
	TablesReadTablesData,
	TablesReadTablesResponse,
	TablesCreateTableData,
	TablesCreateTableResponse,
	TablesReadTableData,
	TablesReadTableResponse,
	TablesUpdateTableData,
	TablesUpdateTableResponse,
	TablesDeleteTableData,
	TablesDeleteTableResponse,
	TablesReadTableMetadataData,
	TablesReadTableMetadataResponse,
	ToolsGetAllToolsData,
	ToolsGetAllToolsResponse,
	ToolsGetToolData,
	ToolsGetToolResponse,
	ToolsSetUserToolVariablesData,
	ToolsSetUserToolVariablesResponse,
	ToolsGetUserToolVariablesData,
	ToolsGetUserToolVariablesResponse,
	ToolsUpdateUserToolVariablesData,
	ToolsUpdateUserToolVariablesResponse,
	ToolsUpdateToolActiveStatusData,
	ToolsUpdateToolActiveStatusResponse,
	UploadGetPresignedUrlData,
	UploadGetPresignedUrlResponse,
	UsersReadUsersData,
	UsersReadUsersResponse,
	UsersCreateUserData,
	UsersCreateUserResponse,
	UsersUpdateUserMeData,
	UsersUpdateUserMeResponse,
	UsersReadUserMeData,
	UsersReadUserMeResponse,
	UsersDeleteUserMeData,
	UsersDeleteUserMeResponse,
	UsersUpdatePasswordMeData,
	UsersUpdatePasswordMeResponse,
	UsersRegisterUserData,
	UsersRegisterUserResponse,
	UsersReadUserByIdData,
	UsersReadUserByIdResponse,
	UsersUpdateUserData,
	UsersUpdateUserResponse,
	UsersDeleteUserData,
	UsersDeleteUserResponse,
	UtilsTestEmailData,
	UtilsTestEmailResponse,
	UtilsHealthCheckResponse,
	WritingsReadWritingsData,
	WritingsReadWritingsResponse,
	WritingsCreateWritingData,
	WritingsCreateWritingResponse,
	WritingsReadWritingData,
	WritingsReadWritingResponse,
	WritingsDeleteWritingData,
	WritingsDeleteWritingResponse,
	WritingsUpdateWritingMetadataData,
	WritingsUpdateWritingMetadataResponse,
	WritingsUpdateWritingContentData,
	WritingsUpdateWritingContentResponse,
	WritingVersionsCreateWritingVersionData,
	WritingVersionsCreateWritingVersionResponse,
	WritingVersionsListWritingVersionsData,
	WritingVersionsListWritingVersionsResponse,
	WritingVersionsGetWritingVersionMetadataData,
	WritingVersionsGetWritingVersionMetadataResponse,
	WritingVersionsUpdateWritingVersionLabelData,
	WritingVersionsUpdateWritingVersionLabelResponse,
	WritingVersionsDeleteWritingVersionData,
	WritingVersionsDeleteWritingVersionResponse,
	WritingVersionsGetWritingVersionContentData,
	WritingVersionsGetWritingVersionContentResponse,
	WritingVersionsUpdateWritingVersionContentData,
	WritingVersionsUpdateWritingVersionContentResponse,
} from "./types.gen"

export class ChatService {
	/**
	 * Upload Document
	 * 문서를 업로드하고 MinIO에 저장하여 파일 ID를 반환합니다.
	 * @param data The data for the request.
	 * @param data.formData
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static uploadDocument(data: ChatUploadDocumentData): CancelablePromise<ChatUploadDocumentResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/chat/upload-document",
			query: {
				query_token: data.queryToken,
			},
			formData: data.formData,
			mediaType: "multipart/form-data",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Summarize Document
	 * 업로드된 문서를 파싱하고 요약합니다.
	 * @param data The data for the request.
	 * @param data.formData
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static summarizeDocument(data: ChatSummarizeDocumentData): CancelablePromise<ChatSummarizeDocumentResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/chat/summarize-document",
			query: {
				query_token: data.queryToken,
			},
			formData: data.formData,
			mediaType: "application/x-www-form-urlencoded",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Document
	 * 업로드된 문서를 MinIO에서 삭제합니다.
	 * @param data The data for the request.
	 * @param data.fileId
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static deleteDocument(data: ChatDeleteDocumentData): CancelablePromise<ChatDeleteDocumentResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/chat/documents/{file_id}",
			path: {
				file_id: data.fileId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create Conversation
	 * Create a new conversation and return `conv_id`.
	 * @param data The data for the request.
	 * @param data.message
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static createConversation(
		data: ChatCreateConversationData,
	): CancelablePromise<ChatCreateConversationResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/chat/conversations",
			query: {
				message: data.message,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read Conversations
	 * Retrieve all conversations owned by the current user.
	 * @param data The data for the request.
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static readConversations(
		data: ChatReadConversationsData = {},
	): CancelablePromise<ChatReadConversationsResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/chat/conversations",
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Sse Messages
	 * Streams assistant response using ChatBotMainWorkflow via SSE.
	 * @param data The data for the request.
	 * @param data.convId
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static sseMessages(data: ChatSseMessagesData): CancelablePromise<ChatSseMessagesResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/chat/conversations/{conv_id}/events",
			path: {
				conv_id: data.convId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read Messages
	 * Retrieve messages from database with IDs.
	 * @param data The data for the request.
	 * @param data.convId
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static readMessages(data: ChatReadMessagesData): CancelablePromise<ChatReadMessagesResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/chat/conversations/{conv_id}/messages",
			path: {
				conv_id: data.convId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Send Message
	 * Saves user message, triggers SSE, and lets SSE handle OpenAI requests.
	 * @param data The data for the request.
	 * @param data.convId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static sendMessage(data: ChatSendMessageData): CancelablePromise<ChatSendMessageResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/chat/conversations/{conv_id}/messages",
			path: {
				conv_id: data.convId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Conversation
	 * Delete a conversation and all its messages.
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static deleteConversation(
		data: ChatDeleteConversationData,
	): CancelablePromise<ChatDeleteConversationResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/chat/conversations/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Conversation Title
	 * Update the title of a conversation.
	 * @param data The data for the request.
	 * @param data.convId
	 * @param data.title
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static updateConversationTitle(
		data: ChatUpdateConversationTitleData,
	): CancelablePromise<ChatUpdateConversationTitleResponse> {
		return __request(OpenAPI, {
			method: "PATCH",
			url: "/api/v1/chat/conversations/{conv_id}/title",
			path: {
				conv_id: data.convId,
			},
			query: {
				title: data.title,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Health Check
	 * 헬스 체크 엔드포인트
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static healthCheck(): CancelablePromise<ChatHealthCheckResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/chat/health",
		})
	}

	/**
	 * Test Workflow
	 * 워크플로우 테스트 엔드포인트
	 * @param data The data for the request.
	 * @param data.message
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static testWorkflow(data: ChatTestWorkflowData): CancelablePromise<ChatTestWorkflowResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/chat/test-workflow",
			query: {
				message: data.message,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class ChatsService {
	/**
	 * Sse Messages
	 * Streams assistant response using ReActAgent and PostgresChatStore via SSE.
	 * @param data The data for the request.
	 * @param data.convId
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static sseMessages(data: ChatsSseMessagesData): CancelablePromise<ChatsSseMessagesResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/chats/conversations/{conv_id}/events",
			path: {
				conv_id: data.convId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create Conversation
	 * Create a new conversation and return `conv_id`.
	 * @param data The data for the request.
	 * @param data.message
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static createConversation(
		data: ChatsCreateConversationData,
	): CancelablePromise<ChatsCreateConversationResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/chats/conversations",
			query: {
				message: data.message,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read Conversations
	 * Retrieve all conversations owned by the current user.
	 * @param data The data for the request.
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns ConversationsPublic Successful Response
	 * @throws ApiError
	 */
	public static readConversations(
		data: ChatsReadConversationsData = {},
	): CancelablePromise<ChatsReadConversationsResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/chats/conversations",
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read Messages
	 * Retrieve messages from LlamaIndex's chat memory store.
	 * @param data The data for the request.
	 * @param data.convId
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static readMessages(data: ChatsReadMessagesData): CancelablePromise<ChatsReadMessagesResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/chats/conversations/{conv_id}/messages",
			path: {
				conv_id: data.convId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Send Message
	 * Saves user message, triggers SSE, and lets SSE handle OpenAI requests.
	 * @param data The data for the request.
	 * @param data.convId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static sendMessage(data: ChatsSendMessageData): CancelablePromise<ChatsSendMessageResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/chats/conversations/{conv_id}/messages",
			path: {
				conv_id: data.convId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Conversation
	 * Delete a conversation and all its messages.
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static deleteConversation(
		data: ChatsDeleteConversationData,
	): CancelablePromise<ChatsDeleteConversationResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/chats/conversations/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Conversation Title
	 * Update the title of a conversation.
	 * @param data The data for the request.
	 * @param data.convId
	 * @param data.title
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static updateConversationTitle(
		data: ChatsUpdateConversationTitleData,
	): CancelablePromise<ChatsUpdateConversationTitleResponse> {
		return __request(OpenAPI, {
			method: "PATCH",
			url: "/api/v1/chats/conversations/{conv_id}/title",
			path: {
				conv_id: data.convId,
			},
			query: {
				title: data.title,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Stream Chat With Maintenance Data
	 * 정비 기록 데이터를 바탕으로 스트리밍 AI 챗봇 응답 생성
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static streamChatWithMaintenanceData(
		data: ChatsStreamChatWithMaintenanceDataData,
	): CancelablePromise<ChatsStreamChatWithMaintenanceDataResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/chats/pm/stream",
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Chat With Maintenance Data
	 * 정비 기록 데이터를 바탕으로 AI 챗봇 응답 생성 (비스트리밍)
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @returns ChatResponse Successful Response
	 * @throws ApiError
	 */
	public static chatWithMaintenanceData(
		data: ChatsChatWithMaintenanceDataData,
	): CancelablePromise<ChatsChatWithMaintenanceDataResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/chats/pm",
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Stream Analyze Maintenance Records
	 * 정비 기록 전체 분석 (스트리밍)
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static streamAnalyzeMaintenanceRecords(
		data: ChatsStreamAnalyzeMaintenanceRecordsData,
	): CancelablePromise<ChatsStreamAnalyzeMaintenanceRecordsResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/chats/pm/analyze/stream",
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Stream Cost Analysis
	 * 비용 분석 전용 엔드포인트 (스트리밍)
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static streamCostAnalysis(
		data: ChatsStreamCostAnalysisData,
	): CancelablePromise<ChatsStreamCostAnalysisResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/chats/pm/cost-analysis/stream",
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Analyze Maintenance Records
	 * 정비 기록 전체 분석 (비스트리밍)
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static analyzeMaintenanceRecords(
		data: ChatsAnalyzeMaintenanceRecordsData,
	): CancelablePromise<ChatsAnalyzeMaintenanceRecordsResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/chats/pm/analyze",
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class ExtractorService {
	/**
	 * Extract Schema
	 * 테이블 기반 MinIO 스토리지를 사용하여 PDF 파일을 비동기로 처리합니다. Celery 태스크를 사용합니다.
	 * @param data The data for the request.
	 * @param data.documentId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static extractSchema(data: ExtractorExtractSchemaData): CancelablePromise<ExtractorExtractSchemaResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/extractor/",
			query: {
				document_id: data.documentId,
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Process Document
	 * 문서를 파싱합니다.
	 * @param data The data for the request.
	 * @param data.documentId
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static processDocument(
		data: ExtractorProcessDocumentData,
	): CancelablePromise<ExtractorProcessDocumentResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/extractor/process-document",
			query: {
				document_id: data.documentId,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Get Extractor Result
	 * Celery 태스크 결과를 조회합니다.
	 * @param data The data for the request.
	 * @param data.taskId
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getExtractorResult(
		data: ExtractorGetExtractorResultData,
	): CancelablePromise<ExtractorGetExtractorResultResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/extractor/result/{task_id}",
			path: {
				task_id: data.taskId,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Stream Extractor Result
	 * SSE를 통해 실시간으로 추출 상태를 스트리밍합니다.
	 * @param data The data for the request.
	 * @param data.taskId
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static streamExtractorResult(
		data: ExtractorStreamExtractorResultData,
	): CancelablePromise<ExtractorStreamExtractorResultResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/extractor/result/{task_id}/stream",
			path: {
				task_id: data.taskId,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Extraction
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static extraction(data: ExtractorExtractionData): CancelablePromise<ExtractorExtractionResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/extractor/extraction",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Mistral Extraction
	 * Mistral 모델을 사용하여 문서를 추출합니다.
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static mistralExtraction(
		data: ExtractorMistralExtractionData,
	): CancelablePromise<ExtractorMistralExtractionResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/extractor/mistral",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class GenerationService {
	/**
	 * Stream Generate Text
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static streamGenerateText(
		data: GenerationStreamGenerateTextData,
	): CancelablePromise<GenerationStreamGenerateTextResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/generate/stream",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class LoginService {
	/**
	 * Login Access Token
	 * OAuth2 compatible token login, get an access token for future requests
	 * @param data The data for the request.
	 * @param data.formData
	 * @returns Token Successful Response
	 * @throws ApiError
	 */
	public static loginAccessToken(data: LoginLoginAccessTokenData): CancelablePromise<LoginLoginAccessTokenResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/login/access-token",
			formData: data.formData,
			mediaType: "application/x-www-form-urlencoded",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Test Token
	 * Test access token
	 * @param data The data for the request.
	 * @param data.queryToken
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static testToken(data: LoginTestTokenData = {}): CancelablePromise<LoginTestTokenResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/login/test-token",
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Recover Password
	 * Password Recovery
	 * @param data The data for the request.
	 * @param data.email
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static recoverPassword(data: LoginRecoverPasswordData): CancelablePromise<LoginRecoverPasswordResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/password-recovery/{email}",
			path: {
				email: data.email,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Reset Password
	 * Reset password
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static resetPassword(data: LoginResetPasswordData): CancelablePromise<LoginResetPasswordResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/reset-password/",
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Recover Password Html Content
	 * HTML Content for Password Recovery
	 * @param data The data for the request.
	 * @param data.email
	 * @param data.queryToken
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static recoverPasswordHtmlContent(
		data: LoginRecoverPasswordHtmlContentData,
	): CancelablePromise<LoginRecoverPasswordHtmlContentResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/password-recovery-html-content/{email}",
			path: {
				email: data.email,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class PrivateService {
	/**
	 * Create User
	 * Create a new user.
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static createUser(data: PrivateCreateUserData): CancelablePromise<PrivateCreateUserResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/private/users/",
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class ReportsService {
	/**
	 * Read Feed Metadata
	 * @param data The data for the request.
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns FeedMetadataList Successful Response
	 * @throws ApiError
	 */
	public static readFeedMetadata(
		data: ReportsReadFeedMetadataData = {},
	): CancelablePromise<ReportsReadFeedMetadataResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/reports/metadata",
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read Feeds
	 * @param data The data for the request.
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns FeedsPublic Successful Response
	 * @throws ApiError
	 */
	public static readFeeds(data: ReportsReadFeedsData = {}): CancelablePromise<ReportsReadFeedsResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/reports/",
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create Feed
	 * Create a new RSS Feed with metadata parsed from the URL.
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns FeedPublic Successful Response
	 * @throws ApiError
	 */
	public static createFeed(data: ReportsCreateFeedData): CancelablePromise<ReportsCreateFeedResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/reports/",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read Feed
	 * Get a feed by ID with parsed RSS items.
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.queryToken
	 * @returns FeedPublic Successful Response
	 * @throws ApiError
	 */
	public static readFeed(data: ReportsReadFeedData): CancelablePromise<ReportsReadFeedResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/reports/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Feed
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns FeedPublic Successful Response
	 * @throws ApiError
	 */
	public static updateFeed(data: ReportsUpdateFeedData): CancelablePromise<ReportsUpdateFeedResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/reports/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Feed
	 * Delete a feed.
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static deleteFeed(data: ReportsDeleteFeedData): CancelablePromise<ReportsDeleteFeedResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/reports/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create Feeds Bulk
	 * Create multiple RSS Feeds.
	 * Skips any feed with duplicate feed_url for the same user.
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns FeedPublic Successful Response
	 * @throws ApiError
	 */
	public static createFeedsBulk(data: ReportsCreateFeedsBulkData): CancelablePromise<ReportsCreateFeedsBulkResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/reports/bulk",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create Report Job
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns ReportJobPublic Successful Response
	 * @throws ApiError
	 */
	public static createReportJob(data: ReportsCreateReportJobData): CancelablePromise<ReportsCreateReportJobResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/reports/job/",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * List Report Jobs
	 * @param data The data for the request.
	 * @param data.reportJobId
	 * @param data.sortKey
	 * @param data.sortOrder
	 * @param data.queryToken
	 * @returns ReportJobPublic Successful Response
	 * @throws ApiError
	 */
	public static listReportJobs(data: ReportsListReportJobsData = {}): CancelablePromise<ReportsListReportJobsResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/reports/job/",
			query: {
				reportJobId: data.reportJobId,
				sort_key: data.sortKey,
				sort_order: data.sortOrder,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Get Report Job
	 * @param data The data for the request.
	 * @param data.jobId
	 * @param data.queryToken
	 * @returns ReportJobPublic Successful Response
	 * @throws ApiError
	 */
	public static getReportJob(data: ReportsGetReportJobData): CancelablePromise<ReportsGetReportJobResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/reports/job/{job_id}",
			path: {
				job_id: data.jobId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Report Job
	 * @param data The data for the request.
	 * @param data.jobId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns ReportJobPublic Successful Response
	 * @throws ApiError
	 */
	public static updateReportJob(data: ReportsUpdateReportJobData): CancelablePromise<ReportsUpdateReportJobResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/reports/job/{job_id}",
			path: {
				job_id: data.jobId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Report Job
	 * @param data The data for the request.
	 * @param data.jobId
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static deleteReportJob(data: ReportsDeleteReportJobData): CancelablePromise<ReportsDeleteReportJobResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/reports/job/{job_id}",
			path: {
				job_id: data.jobId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * List Reports By Job Id
	 * @param data The data for the request.
	 * @param data.jobId
	 * @param data.queryToken
	 * @returns ReportPublic Successful Response
	 * @throws ApiError
	 */
	public static listReportsByJobId(
		data: ReportsListReportsByJobIdData,
	): CancelablePromise<ReportsListReportsByJobIdResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/reports/report/job/{job_id}/reports",
			path: {
				job_id: data.jobId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Report
	 * @param data The data for the request.
	 * @param data.reportId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns ReportPublic Successful Response
	 * @throws ApiError
	 */
	public static updateReport(data: ReportsUpdateReportData): CancelablePromise<ReportsUpdateReportResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/reports/report/{report_id}",
			path: {
				report_id: data.reportId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Get Report By Id
	 * @param data The data for the request.
	 * @param data.reportId
	 * @param data.queryToken
	 * @returns ReportPublic Successful Response
	 * @throws ApiError
	 */
	public static getReportById(data: ReportsGetReportByIdData): CancelablePromise<ReportsGetReportByIdResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/reports/report/{report_id}",
			path: {
				report_id: data.reportId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create Report
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns ReportPublic Successful Response
	 * @throws ApiError
	 */
	public static createReport(data: ReportsCreateReportData): CancelablePromise<ReportsCreateReportResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/reports/report/",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class SchemaService {
	/**
	 * Create Schema
	 * 새로운 스키마를 생성합니다.
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns SchemaPublic Successful Response
	 * @throws ApiError
	 */
	public static createSchema(data: SchemaCreateSchemaData): CancelablePromise<SchemaCreateSchemaResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/schema/",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Get Schemas
	 * 현재 사용자의 모든 스키마를 조회합니다.
	 * @param data The data for the request.
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns SchemasPublic Successful Response
	 * @throws ApiError
	 */
	public static getSchemas(data: SchemaGetSchemasData = {}): CancelablePromise<SchemaGetSchemasResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/schema/",
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Get Schema
	 * 특정 스키마를 조회합니다.
	 * @param data The data for the request.
	 * @param data.schemaId
	 * @param data.queryToken
	 * @returns SchemaPublic Successful Response
	 * @throws ApiError
	 */
	public static getSchema(data: SchemaGetSchemaData): CancelablePromise<SchemaGetSchemaResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/schema/{schema_id}",
			path: {
				schema_id: data.schemaId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Schema
	 * 특정 스키마를 업데이트합니다.
	 * @param data The data for the request.
	 * @param data.schemaId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns SchemaPublic Successful Response
	 * @throws ApiError
	 */
	public static updateSchema(data: SchemaUpdateSchemaData): CancelablePromise<SchemaUpdateSchemaResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/schema/{schema_id}",
			path: {
				schema_id: data.schemaId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Schema
	 * 특정 스키마를 삭제합니다.
	 * @param data The data for the request.
	 * @param data.schemaId
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static deleteSchema(data: SchemaDeleteSchemaData): CancelablePromise<SchemaDeleteSchemaResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/schema/{schema_id}",
			path: {
				schema_id: data.schemaId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class StorageService {
	/**
	 * Get Presigned Url
	 * 파일 다운로드를 위한 presigned URL을 생성합니다.
	 * @param data The data for the request.
	 * @param data.objectName MinIO 오브젝트 이름 (전체 경로)
	 * @param data.pageNumber
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getPresignedUrl(data: StorageGetPresignedUrlData): CancelablePromise<StorageGetPresignedUrlResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/storage/presigned-url",
			query: {
				object_name: data.objectName,
				page_number: data.pageNumber,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create Folder
	 * 프론트엔드에서 전달받은 폴더명(한글)과 버킷명(영문)으로 새 폴더를 생성합니다.
	 *
	 * 예시 요청:
	 * {
	 * "folder_name": "나의 첫번째 폴더",
	 * "prefix_name": "prefix-key"
	 * }
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static createFolder(data: StorageCreateFolderData): CancelablePromise<StorageCreateFolderResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/storage/create-folder",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Folder
	 * 지정한 폴더를 업데이트합니다.
	 * @param data The data for the request.
	 * @param data.folderId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static updateFolder(data: StorageUpdateFolderData): CancelablePromise<StorageUpdateFolderResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/storage/folders/{folder_id}",
			path: {
				folder_id: data.folderId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Folder
	 * 지정한 폴더를 삭제합니다. MinIO에서 폴더와 모든 파일을 삭제하고 DB에서도 정보를 제거합니다.
	 * @param data The data for the request.
	 * @param data.folderId
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static deleteFolder(data: StorageDeleteFolderData): CancelablePromise<StorageDeleteFolderResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/storage/folders/{folder_id}",
			path: {
				folder_id: data.folderId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read Folders
	 * Retrieve folders list.
	 * @param data The data for the request.
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns FoldersPublic Successful Response
	 * @throws ApiError
	 */
	public static readFolders(data: StorageReadFoldersData = {}): CancelablePromise<StorageReadFoldersResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/storage/",
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * List Folders
	 * 현재 유저가 소유한 폴더 리스트를 반환합니다.
	 * 슈퍼유저인 경우 모든 폴더를 반환합니다.
	 * @param data The data for the request.
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static listFolders(data: StorageListFoldersData = {}): CancelablePromise<StorageListFoldersResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/storage/folders",
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * List Files
	 * 지정한 폴더의 파일(오브젝트) 목록을 반환합니다.
	 * @param data The data for the request.
	 * @param data.prefixName 폴더의 prefix 이름
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static listFiles(data: StorageListFilesData): CancelablePromise<StorageListFilesResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/storage/files",
			query: {
				prefix_name: data.prefixName,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Files
	 * document_id를 기반으로 파일을 삭제합니다.
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static deleteFiles(data: StorageDeleteFilesData): CancelablePromise<StorageDeleteFilesResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/storage/files",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Upload Files
	 * 통합 파일 업로드 엔드포인트입니다.
	 * context_id가 폴더인지 테이블인지는 자동으로 판단합니다.
	 *
	 * Args:
	 * session: 데이터베이스 세션
	 * current_user: 현재 로그인한 사용자
	 * context_id: 폴더 ID 또는 테이블 ID
	 * files: 업로드할 파일 목록
	 * use_schema: 스키마 기반 파싱 사용 여부 (기본값: False)
	 * @param data The data for the request.
	 * @param data.formData
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static uploadFiles(data: StorageUploadFilesData): CancelablePromise<StorageUploadFilesResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/storage/upload/files",
			query: {
				query_token: data.queryToken,
			},
			formData: data.formData,
			mediaType: "multipart/form-data",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Get Document Status
	 * 문서의 처리 상태를 조회합니다.
	 * @param data The data for the request.
	 * @param data.documentId
	 * @param data.folderName 폴더의 폴더 이름
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getDocumentStatus(
		data: StorageGetDocumentStatusData,
	): CancelablePromise<StorageGetDocumentStatusResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/storage/documents/{document_id}",
			path: {
				document_id: data.documentId,
			},
			query: {
				folder_name: data.folderName,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * List Documents
	 * 현재 사용자의 문서 목록을 조회합니다.
	 * @param data The data for the request.
	 * @param data.skip
	 * @param data.limit
	 * @param data.status
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static listDocuments(data: StorageListDocumentsData = {}): CancelablePromise<StorageListDocumentsResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/storage/documents",
			query: {
				skip: data.skip,
				limit: data.limit,
				status: data.status,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * List Files With Status In Folder
	 * @param data The data for the request.
	 * @param data.folderId
	 * @param data.status
	 * @param data.queryToken
	 * @returns FilesWithStatusResponse Successful Response
	 * @throws ApiError
	 */
	public static listFilesWithStatusInFolder(
		data: StorageListFilesWithStatusInFolderData,
	): CancelablePromise<StorageListFilesWithStatusInFolderResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/storage/folders/{folder_id}/files-with-status",
			path: {
				folder_id: data.folderId,
			},
			query: {
				status: data.status,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Stream Folder Status
	 * SSE를 통해 폴더 내 파일들의 상태를 실시간으로 스트리밍합니다.
	 * @param data The data for the request.
	 * @param data.folderId
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static streamFolderStatus(
		data: StorageStreamFolderStatusData,
	): CancelablePromise<StorageStreamFolderStatusResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/storage/folders/{folder_id}/status-stream",
			path: {
				folder_id: data.folderId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class TableFieldsService {
	/**
	 * Read Table Fields
	 * Retrieve fields for a specific table.
	 * @param data The data for the request.
	 * @param data.tableId
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns TableFieldsPublic Successful Response
	 * @throws ApiError
	 */
	public static readTableFields(
		data: TableFieldsReadTableFieldsData,
	): CancelablePromise<TableFieldsReadTableFieldsResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/tableFields/{table_id}",
			path: {
				table_id: data.tableId,
			},
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create Table Field
	 * Create a new field for a specific table and associate metadata (if applicable).
	 * @param data The data for the request.
	 * @param data.tableId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns TableFieldPublic Successful Response
	 * @throws ApiError
	 */
	public static createTableField(
		data: TableFieldsCreateTableFieldData,
	): CancelablePromise<TableFieldsCreateTableFieldResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/tableFields/{table_id}",
			path: {
				table_id: data.tableId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read Table Field
	 * Get a table field by ID.
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.queryToken
	 * @returns TableFieldPublic Successful Response
	 * @throws ApiError
	 */
	public static readTableField(
		data: TableFieldsReadTableFieldData,
	): CancelablePromise<TableFieldsReadTableFieldResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/tableFields/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Table Field
	 * Update a field's name, description, is_required status, and metadata.
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns TableFieldPublic Successful Response
	 * @throws ApiError
	 */
	public static updateTableField(
		data: TableFieldsUpdateTableFieldData,
	): CancelablePromise<TableFieldsUpdateTableFieldResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/tableFields/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Table Field
	 * Delete a table field and remove all data associated with that field ID from TableRow entries.
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static deleteTableField(
		data: TableFieldsDeleteTableFieldData,
	): CancelablePromise<TableFieldsDeleteTableFieldResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/tableFields/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class TableRowsService {
	/**
	 * Read Table Rows
	 * Read rows from OpenSearch for a specific table, sorted by created_at descending.
	 * @param data The data for the request.
	 * @param data.tableId
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns TableRowsResponse Successful Response
	 * @throws ApiError
	 */
	public static readTableRows(data: TableRowsReadTableRowsData): CancelablePromise<TableRowsReadTableRowsResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/tableRows/{table_id}",
			path: {
				table_id: data.tableId,
			},
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create Table Row
	 * Add a new row to the specified table (OpenSearch index).
	 * @param data The data for the request.
	 * @param data.tableId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static createTableRow(data: TableRowsCreateTableRowData): CancelablePromise<TableRowsCreateTableRowResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/tableRows/{table_id}",
			path: {
				table_id: data.tableId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Table Row
	 * Update a row document in OpenSearch.
	 * @param data The data for the request.
	 * @param data.tableId
	 * @param data.tableRowId
	 * @param data.requestBody
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static updateTableRow(data: TableRowsUpdateTableRowData): CancelablePromise<TableRowsUpdateTableRowResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/tableRows/{table_id}/row/{tableRow_id}",
			path: {
				table_id: data.tableId,
				tableRow_id: data.tableRowId,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Table Row
	 * Delete a row document from OpenSearch.
	 * @param data The data for the request.
	 * @param data.tableId
	 * @param data.tableRowId
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static deleteTableRow(data: TableRowsDeleteTableRowData): CancelablePromise<TableRowsDeleteTableRowResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/tableRows/{table_id}/row/{tableRow_id}",
			path: {
				table_id: data.tableId,
				tableRow_id: data.tableRowId,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class TablesService {
	/**
	 * Read Tables
	 * Retrieve tables.
	 * @param data The data for the request.
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns TablesPublic Successful Response
	 * @throws ApiError
	 */
	public static readTables(data: TablesReadTablesData = {}): CancelablePromise<TablesReadTablesResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/tables/",
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create Table
	 * Create a new table.
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns TablePublic Successful Response
	 * @throws ApiError
	 */
	public static createTable(data: TablesCreateTableData): CancelablePromise<TablesCreateTableResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/tables/",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read Table
	 * Get a table by ID.
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.queryToken
	 * @returns TablePublic Successful Response
	 * @throws ApiError
	 */
	public static readTable(data: TablesReadTableData): CancelablePromise<TablesReadTableResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/tables/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Table
	 * Update a table.
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns TablePublic Successful Response
	 * @throws ApiError
	 */
	public static updateTable(data: TablesUpdateTableData): CancelablePromise<TablesUpdateTableResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/tables/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Table
	 * 특정 테이블을 삭제하는 함수입니다. (파일 관련 삭제는 제외)
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static deleteTable(data: TablesDeleteTableData): CancelablePromise<TablesDeleteTableResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/tables/tables/{table_id}",
			query: {
				id: data.id,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read Table Metadata
	 * Get table metadata from OpenSearch __meta document.
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static readTableMetadata(
		data: TablesReadTableMetadataData,
	): CancelablePromise<TablesReadTableMetadataResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/tables/{id}/metadata",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class ToolsService {
	/**
	 * Get All Tools
	 * @param data The data for the request.
	 * @param data.queryToken
	 * @returns ToolListPublic Successful Response
	 * @throws ApiError
	 */
	public static getAllTools(data: ToolsGetAllToolsData = {}): CancelablePromise<ToolsGetAllToolsResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/tools/",
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Get Tool
	 * @param data The data for the request.
	 * @param data.toolId
	 * @param data.queryToken
	 * @returns ToolDetailPublic Successful Response
	 * @throws ApiError
	 */
	public static getTool(data: ToolsGetToolData): CancelablePromise<ToolsGetToolResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/tools/{tool_id}",
			path: {
				tool_id: data.toolId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Set User Tool Variables
	 * @param data The data for the request.
	 * @param data.toolId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static setUserToolVariables(
		data: ToolsSetUserToolVariablesData,
	): CancelablePromise<ToolsSetUserToolVariablesResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/tools/{tool_id}/user-variables",
			path: {
				tool_id: data.toolId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Get User Tool Variables
	 * @param data The data for the request.
	 * @param data.toolId
	 * @param data.queryToken
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static getUserToolVariables(
		data: ToolsGetUserToolVariablesData,
	): CancelablePromise<ToolsGetUserToolVariablesResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/tools/{tool_id}/user_vars",
			path: {
				tool_id: data.toolId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update User Tool Variables
	 * @param data The data for the request.
	 * @param data.toolId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static updateUserToolVariables(
		data: ToolsUpdateUserToolVariablesData,
	): CancelablePromise<ToolsUpdateUserToolVariablesResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/tools/{tool_id}/user_vars",
			path: {
				tool_id: data.toolId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Tool Active Status
	 * @param data The data for the request.
	 * @param data.toolId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns ToolPublic Successful Response
	 * @throws ApiError
	 */
	public static updateToolActiveStatus(
		data: ToolsUpdateToolActiveStatusData,
	): CancelablePromise<ToolsUpdateToolActiveStatusResponse> {
		return __request(OpenAPI, {
			method: "PATCH",
			url: "/api/v1/tools/{tool_id}/active",
			path: {
				tool_id: data.toolId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class UploadService {
	/**
	 * Get Presigned Url
	 * @param data The data for the request.
	 * @param data.contentType The MIME type of the file to upload
	 * @param data.tableId ID of the table to associate the file with
	 * @returns PresignedUrlResponse Successful Response
	 * @throws ApiError
	 */
	public static getPresignedUrl(data: UploadGetPresignedUrlData): CancelablePromise<UploadGetPresignedUrlResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/upload/",
			query: {
				content_type: data.contentType,
				table_id: data.tableId,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class UsersService {
	/**
	 * Read Users
	 * Retrieve users.
	 * @param data The data for the request.
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns UsersPublic Successful Response
	 * @throws ApiError
	 */
	public static readUsers(data: UsersReadUsersData = {}): CancelablePromise<UsersReadUsersResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/users/",
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create User
	 * Create new user.
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static createUser(data: UsersCreateUserData): CancelablePromise<UsersCreateUserResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/users/",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update User Me
	 * Update own user.
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static updateUserMe(data: UsersUpdateUserMeData): CancelablePromise<UsersUpdateUserMeResponse> {
		return __request(OpenAPI, {
			method: "PATCH",
			url: "/api/v1/users/me",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read User Me
	 * Get current user.
	 * @param data The data for the request.
	 * @param data.queryToken
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static readUserMe(data: UsersReadUserMeData = {}): CancelablePromise<UsersReadUserMeResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/users/me",
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete User Me
	 * Delete own user.
	 * @param data The data for the request.
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static deleteUserMe(data: UsersDeleteUserMeData = {}): CancelablePromise<UsersDeleteUserMeResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/users/me",
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Password Me
	 * Update own password.
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static updatePasswordMe(data: UsersUpdatePasswordMeData): CancelablePromise<UsersUpdatePasswordMeResponse> {
		return __request(OpenAPI, {
			method: "PATCH",
			url: "/api/v1/users/me/password",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Register User
	 * Create new user without the need to be logged in.
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static registerUser(data: UsersRegisterUserData): CancelablePromise<UsersRegisterUserResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/users/signup",
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read User By Id
	 * Get a specific user by id.
	 * @param data The data for the request.
	 * @param data.userId
	 * @param data.queryToken
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static readUserById(data: UsersReadUserByIdData): CancelablePromise<UsersReadUserByIdResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/users/{user_id}",
			path: {
				user_id: data.userId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update User
	 * Update a user.
	 * @param data The data for the request.
	 * @param data.userId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static updateUser(data: UsersUpdateUserData): CancelablePromise<UsersUpdateUserResponse> {
		return __request(OpenAPI, {
			method: "PATCH",
			url: "/api/v1/users/{user_id}",
			path: {
				user_id: data.userId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete User
	 * Delete a user.
	 * @param data The data for the request.
	 * @param data.userId
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static deleteUser(data: UsersDeleteUserData): CancelablePromise<UsersDeleteUserResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/users/{user_id}",
			path: {
				user_id: data.userId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class UtilsService {
	/**
	 * Test Email
	 * Test emails.
	 * @param data The data for the request.
	 * @param data.emailTo
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static testEmail(data: UtilsTestEmailData): CancelablePromise<UtilsTestEmailResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/utils/test-email/",
			query: {
				email_to: data.emailTo,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Health Check
	 * @returns boolean Successful Response
	 * @throws ApiError
	 */
	public static healthCheck(): CancelablePromise<UtilsHealthCheckResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/utils/health-check/",
		})
	}
}

export class WritingsService {
	/**
	 * Read Writings
	 * @param data The data for the request.
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns WritingsPublic Successful Response
	 * @throws ApiError
	 */
	public static readWritings(data: WritingsReadWritingsData = {}): CancelablePromise<WritingsReadWritingsResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/writings/",
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Create Writing
	 * @param data The data for the request.
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns WritingPublic Successful Response
	 * @throws ApiError
	 */
	public static createWriting(data: WritingsCreateWritingData): CancelablePromise<WritingsCreateWritingResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/writings/",
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Read Writing
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.queryToken
	 * @returns WritingPublic Successful Response
	 * @throws ApiError
	 */
	public static readWriting(data: WritingsReadWritingData): CancelablePromise<WritingsReadWritingResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/writings/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Writing
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static deleteWriting(data: WritingsDeleteWritingData): CancelablePromise<WritingsDeleteWritingResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/writings/{id}",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Writing Metadata
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns WritingMetadataPublic Successful Response
	 * @throws ApiError
	 */
	public static updateWritingMetadata(
		data: WritingsUpdateWritingMetadataData,
	): CancelablePromise<WritingsUpdateWritingMetadataResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/writings/{id}/metadata",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Writing Content
	 * @param data The data for the request.
	 * @param data.id
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns WritingPublic Successful Response
	 * @throws ApiError
	 */
	public static updateWritingContent(
		data: WritingsUpdateWritingContentData,
	): CancelablePromise<WritingsUpdateWritingContentResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/writings/{id}/content",
			path: {
				id: data.id,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}
}

export class WritingVersionsService {
	/**
	 * Create Writing Version
	 * @param data The data for the request.
	 * @param data.writingId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns WritingVersionMetadata Successful Response
	 * @throws ApiError
	 */
	public static createWritingVersion(
		data: WritingVersionsCreateWritingVersionData,
	): CancelablePromise<WritingVersionsCreateWritingVersionResponse> {
		return __request(OpenAPI, {
			method: "POST",
			url: "/api/v1/writings/{writing_id}/versions/",
			path: {
				writing_id: data.writingId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * List Writing Versions
	 * @param data The data for the request.
	 * @param data.writingId
	 * @param data.skip
	 * @param data.limit
	 * @param data.queryToken
	 * @returns WritingVersionsPublic Successful Response
	 * @throws ApiError
	 */
	public static listWritingVersions(
		data: WritingVersionsListWritingVersionsData,
	): CancelablePromise<WritingVersionsListWritingVersionsResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/writings/{writing_id}/versions/",
			path: {
				writing_id: data.writingId,
			},
			query: {
				skip: data.skip,
				limit: data.limit,
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Get Writing Version Metadata
	 * @param data The data for the request.
	 * @param data.writingId
	 * @param data.versionId
	 * @param data.queryToken
	 * @returns WritingVersionMetadata Successful Response
	 * @throws ApiError
	 */
	public static getWritingVersionMetadata(
		data: WritingVersionsGetWritingVersionMetadataData,
	): CancelablePromise<WritingVersionsGetWritingVersionMetadataResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/writings/{writing_id}/versions/{version_id}",
			path: {
				writing_id: data.writingId,
				version_id: data.versionId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Writing Version Label
	 * @param data The data for the request.
	 * @param data.writingId
	 * @param data.versionId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns WritingVersionMetadata Successful Response
	 * @throws ApiError
	 */
	public static updateWritingVersionLabel(
		data: WritingVersionsUpdateWritingVersionLabelData,
	): CancelablePromise<WritingVersionsUpdateWritingVersionLabelResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/writings/{writing_id}/versions/{version_id}",
			path: {
				writing_id: data.writingId,
				version_id: data.versionId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Delete Writing Version
	 * @param data The data for the request.
	 * @param data.writingId
	 * @param data.versionId
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static deleteWritingVersion(
		data: WritingVersionsDeleteWritingVersionData,
	): CancelablePromise<WritingVersionsDeleteWritingVersionResponse> {
		return __request(OpenAPI, {
			method: "DELETE",
			url: "/api/v1/writings/{writing_id}/versions/{version_id}",
			path: {
				writing_id: data.writingId,
				version_id: data.versionId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Get Writing Version Content
	 * @param data The data for the request.
	 * @param data.writingId
	 * @param data.versionId
	 * @param data.queryToken
	 * @returns WritingVersionContent Successful Response
	 * @throws ApiError
	 */
	public static getWritingVersionContent(
		data: WritingVersionsGetWritingVersionContentData,
	): CancelablePromise<WritingVersionsGetWritingVersionContentResponse> {
		return __request(OpenAPI, {
			method: "GET",
			url: "/api/v1/writings/{writing_id}/versions/{version_id}/content",
			path: {
				writing_id: data.writingId,
				version_id: data.versionId,
			},
			query: {
				query_token: data.queryToken,
			},
			errors: {
				422: "Validation Error",
			},
		})
	}

	/**
	 * Update Writing Version Content
	 * @param data The data for the request.
	 * @param data.writingId
	 * @param data.versionId
	 * @param data.requestBody
	 * @param data.queryToken
	 * @returns Message_Output Successful Response
	 * @throws ApiError
	 */
	public static updateWritingVersionContent(
		data: WritingVersionsUpdateWritingVersionContentData,
	): CancelablePromise<WritingVersionsUpdateWritingVersionContentResponse> {
		return __request(OpenAPI, {
			method: "PUT",
			url: "/api/v1/writings/{writing_id}/versions/{version_id}/content",
			path: {
				writing_id: data.writingId,
				version_id: data.versionId,
			},
			query: {
				query_token: data.queryToken,
			},
			body: data.requestBody,
			mediaType: "application/json",
			errors: {
				422: "Validation Error",
			},
		})
	}
}
